import React, { useEffect, useRef, useState } from "react";
import { Icon, IconButton, IconName } from "stories/Admin";
import styles from "./UsersPage.module.scss";

export interface RowMenuItem {
  label: string;
  icon: IconName;
  danger?: boolean;
  onClick: () => void;
}

/** «Flere valg» button with a small popup menu. */
const RowMenu: React.FC<{ items: RowMenuItem[]; label?: string }> = ({
  items,
  label = "Flere valg",
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className={styles.menuWrap} ref={ref}>
      <IconButton
        label={label}
        size="sm"
        icon={<Icon name="more" size={18} />}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      />
      {open && (
        <div className={styles.menu} role="menu">
          {items.map((item) => (
            <button
              key={item.label}
              type="button"
              role="menuitem"
              className={item.danger ? styles.menuDanger : styles.menuItem}
              onClick={() => {
                setOpen(false);
                item.onClick();
              }}
            >
              <Icon name={item.icon} size={16} />
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RowMenu;
